<template>
  <nuxt-link
    tag="button"
    :to="to"
    class="w-full lg:w-auto hover:bg-blue-100 hover:text-blue-900 bg-blue-900 text-white lg:bg-transparent lg:text-blue-900 font-bold py-2 px-4 mt-2 lg:mt-0 rounded flex items-center"
  >
    <div class="inline-flex">
      <unicon :name="name" fill="currentColor"></unicon>
    </div>
    <div class="ml-1">{{ label }}</div>
  </nuxt-link>
</template>

<script>
export default {
  props: ['label', 'to', 'name']
}
</script>
